import React from 'react';
import DetailsTrades from '../components/DetailsTrades';

const ListTrades = () => (
  <>
    <DetailsTrades />
  </>
);

export default ListTrades;
